// extracted by mini-css-extract-plugin
module.exports = {"type_block":"a10a3f92e9--type_block--wWg22","type":"a10a3f92e9--type--WjAXn","type_block--without_icon":"a10a3f92e9--type_block--without_icon--xeYb9"};